/* eslint-disable */
export default {
  forward: 'Reenc.',
  ignore: 'Ignorar',
  toVoicemail: 'Para correio de voz',
  answer: 'Atender',
  endAndAnswer: 'Terminar e atender',
  holdAndAnswer: 'Em espera e atender',
  custom: 'Personalizado',
  more: 'Mais',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
